module.exports = __webpack_public_path__ + "img/link-banner-vi.d6e1f4cd.png";